export enum PaymentChannel {
    BILLPAY = 'billpay',
    CASH_WALK_IN = 'cash-walk-in',
    CHECK = 'check',
    CHECK_LOCKBOX = 'check-lockbox',
    CHECK_REMOTE_LOCKBOX = 'check-remote-lockbox',
    MOBILE = 'mobile',
    THIRD_PARTY_NACHA_FILE = 'third-party-nacha-file',
    WEB = 'web'
}
